<template>
  <!-- 可报名的会议及可参加的会议 -->
  <div>
    <div id="anchorTagTwo" v-if="newTickets.length !== 0" class="h">
      会议报名
    </div>
    <div
      v-for="(item, index) in newTickets.filter(
        (v) => v.meetingState !== undefined
      )"
      :key="index"
      class="not-enroll"
    >
      <div :style="item.meetingState | meetingbackground" class="each">
        <div class="left">
          <div :style="item.meetingState | meetingTheColor" class="h">
            <span>{{ item.meetingState | registrationStatus }}</span>
            <span
              style="
                margin-left: 10px;
                font-size: 14px;
                color: red;
                font-weight: 400;
              "
              v-if="isFull && item.meetingState === 3"
              >会议人数已达上限</span
            >
          </div>
          <div class="time">
            报名时间：{{ item.beginTime.slice(0,10) }} - {{ item.endTime.slice(0,10) }}
          </div>
          <span class="money"
            >费用: <span class="num">{{ item.price }}</span></span
          >
        </div>
        <div class="right">
          <Button
            v-throttleClick
            :style="item.meetingState | butbackColor"
            @click="signUpImmediately(item.meetingState)"
            class="but"
            >立即报名</Button
          >
        </div>
      </div>
      <div
        v-if="item.meetingState === 4 || item.meetingState === 5"
        class="shadow"
      >
        <div class="begin">{{ item.meetingState | SessionState }}</div>
        <div
          v-if="item.meetingState === 4 && detailsData.meetingType === 1"
          @click="enterTheMeeting"
          class="enter"
        >
          进入会议
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "RegistrableConference",
  computed: {
    ...mapState(["hasLogin"]),
  },
  props: {
    detailsData: {
      default: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tickets: [], // 我的门票
      newTickets: [], // 新的门票数组(增加了会议状态)
      hyBeginTime: "", // 会议开始
      hyendTime: "", // 会议结束
      bmBeginTime: "", // 报名开始
      bmEndTime: "", // 报名结束
      isFull: false, // 会议报名人数是否到达上限
    };
  },
  // 控制会议报名状态
  filters: {
    // 报名状态
    registrationStatus(num) {
      if (num === 1) return "报名已开启";
      if (num === 2) return "报名未开启";
      if (num === 3 || num === 4 || num === 5) return "报名已截止";
    },
    // 会议状态
    SessionState(num) {
      if (num === 4) return "会议已开始";
      if (num === 5) return "会议已结束";
    },
    meetingTheColor(num) {
      if (num === 1) return "color:#0344A1";
      if (num === 2 || num === 3 || num === 4 || num === 5)
        return "color:#757575";
    },
    meetingbackground(num) {
      if (num === 2 || num === 3) return "background:#f6f6f6";
    },
    butbackColor(num) {
      if (num == 1) return "bakcground:#4585f5";
      if (num == 2 || num === 3 || num === 4 || num === 5)
        return "background:#999999";
    },
  },
  created() {
    this.getSignUpInfo();
  },
  methods: {
    // 如果是线上会议,则进入会议网址
    enterTheMeeting() {
      if (this.detailsData.meetingType === 1) {
        window.open(this.detailsData.address);
      }
    },
    // 获取会议门票
    async getSignUpInfo() {
      const res = await this.$apis.userServe.getSignUpInfo({
        id: this.$route.query.id,
      });
      this.tickets = res.data.tickets;
      this.hyBeginTime = res.data.beginTime;
      this.hyendTime = res.data.endTime;
      this.isFull = res.content.full === 1;
      this.sessionState();
    },
    // 判断会议状态并将状态追加到新数组中
    sessionState() {
      this.tickets.forEach((it) => {
        let status = this.judgeState(
          it.beginTime,
          it.endTime,
          this.hyBeginTime,
          this.hyendTime
        );
        it.meetingState = status;
        this.newTickets.push(it);
      });
    },
    // 会议状态判断处理函数
    judgeState(bmBegin, bmEnd, hyBegin, hyEnd) {
      let RealTime = new Date().getTime(); // 实时时间
      let bmBegins = new Date(bmBegin).getTime(); // 报名开始

      // 将报名结束时间改为当天最后时间
      let arr = bmEnd.split(" ")
      arr[1] = "23:59:59"
      let bmEndTime = arr.join(' ')
      let bmEnds = new Date(bmEndTime).getTime(); // 报名结束
      
      let hyBegins = new Date(hyBegin).getTime(); // 会议开始
      let hyEnds = new Date(hyEnd).getTime(); // 会议结束
      if (RealTime >= hyEnds) {
        // 会议结束
        return 5;
      } else if (RealTime >= hyBegins && RealTime <= hyEnds) {
        // 会议已开始
        return 4;
      } else if (RealTime >= bmEnds || this.isFull) {
        // 会议已截止 (超过报名时间或者报名人数上限)
        return 3;
      } else if (RealTime < bmBegins) {
        // 报名未开启
        return 2;
      } else if (RealTime >= bmBegins && RealTime < bmEnds) {
        // 报名已开始
        return 1;
      }
    },
    // 立即报名
    signUpImmediately(meetingState) {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return
      }
      switch (meetingState) {
        case 1:
          this.$emit("upImmediatelyference");
          break;
        case 2:
          this.$Message.warning("报名未开启");
          break;
        case 3:
          this.$Message.warning("报名已截止");
          break;
        case 4:
          this.$Message.warning("会议已开始");
          break;
        case 5:
          this.$Message.warning("会议已结束");
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.h {
  font-size: 16px;
  color: #0344a1;
  font-weight: bold;
}
.not-enroll {
  margin-top: 25px;
  margin-bottom: 20px;
  position: relative;
  .each {
    width: 100%;
    height: 90px;
    padding: 0 20px;
    background: #e0ebff;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    .left {
      margin-top: 15px;
      line-height: 30px;
      .h {
        font-size: 16px;
        color: #0344a1;
      }
      .time {
        font-size: 12px;
        color: #333333;
      }
      .money {
        display: inline;
        vertical-align: top;
        position: relative;
        left: 400px;
        top: -45px;
        .num {
          width: 100px;
          font-size: 18px;
          position: relative;
          top: 2px;
        }
      }
    }
    .right {
      line-height: 90px;
      .but {
        width: 110px;
        height: 40px;
        background: #4585f5;
        color: #fff;
      }
    }
  }
  .shadow {
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 0px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.459);
    color: #fff;
    line-height: 90px;
    .begin {
      margin-right: 20px;
    }
    .enter {
      width: 110px;
      height: 40px;
      margin-top: 25px;
      background: #4585f5;
      line-height: 40px;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
</style>
